module.exports = __webpack_public_path__ + "img/Lincoln.48051d85.jpg";